import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    // 定义应用的状态
    count: 0,
    pageData:{}
  },
  mutations: {
    // 定义修改状态的方法
    increment(state) {
      state.count++;
    },
    setPageData(state, data) {
      state.pageData = data;
    },
  },
  actions: {
    setPageTitle({ commit }, title) {
      document.title = title;
    },
    setPageData({ commit }, data) {
      commit('setPageData', data);
    },
    // 定义触发mutations的方法
    increment(context) {
      context.commit('increment');
    },
  },
});

export default store;